import {
  useBreakpointValue,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
} from '@chakra-ui/react';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Image from 'next/image';
import React from 'react';

import { clickLPCheckCastVideosButton } from '@/utils/analytics/log-event';

import { CastDetail } from './CastDetails';

type Props = {
  cast: CastDetail;
};

const Component: React.FC<Props> = ({ cast }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const modalSize = useBreakpointValue({ base: 'xs', md: '2xl' });
  return (
    <>
      <div
        className="flex cursor-pointer text-sm font-bold text-gray-400"
        onClick={() => {
          onOpen();
          clickLPCheckCastVideosButton(cast.romajiName);
        }}
      >
        <div className="flex items-center justify-center rounded border-2 border-orange-500 px-[5px] text-[9px] text-orange-500">
          <FontAwesomeIcon icon={faPlay} />
        </div>
        <div className="ml-3">出演動画</div>
      </div>
      <Modal isOpen={isOpen} onClose={onClose} size={modalSize} isCentered>
        <ModalOverlay />
        <ModalContent>
          <div className="p-3">
            <div className="mb-4 flex font-bold">
              <Image
                src={cast.modal.image}
                alt=""
                className="mr-3 block h-[95px] w-[95px]"
              />
              <div className="mt-2">
                <div>{cast.name}</div>
                <div className="text-sm font-normal">
                  {cast.modal.description}
                </div>
              </div>
            </div>
            <div>
              <div className="mb-1 text-sm font-bold text-orange-600">
                出演動画
              </div>
              <div className="flex flex-col gap-y-2">
                {cast.modal.lessons.map(lesson => (
                  <div key={lesson.title} className="flex">
                    <div className="flex-none basis-1/3 md:flex-initial md:basis-auto">
                      <Image src={lesson.image} alt="" />
                    </div>
                    <div className="ml-2 text-sm font-bold">{lesson.title}</div>
                  </div>
                ))}
              </div>
              <div className="mt-5 text-center text-sm font-bold text-orange-600">
                ほかにも多くの動画に出演！
              </div>
            </div>
          </div>
          <div className="mt-2 flex items-center justify-center rounded-b-lg bg-gray-100 focus-visible:outline-none">
            <button
              className="flex w-full items-center justify-center p-4 text-sm focus-visible:outline-none"
              onClick={onClose}
            >
              閉じる
            </button>
          </div>
        </ModalContent>
      </Modal>
    </>
  );
};

export default Component;
